<div class="container">
  <mat-card appearance="outlined">
    @if (canDownload) {
      <div>
        {{ "dataExports.message" | translate }}
        <a (click)="downloadFile()">{{ "dataExports.linkText" | translate }}</a>
      </div>
    }

    @if (!canDownload) {
      <div>
        {{ "dataExports.noFile" | translate }}
      </div>
    }
  </mat-card>
</div>
